import { render, staticRenderFns } from "./select-triplet.vue?vue&type=template&id=aa22722e&"
import script from "./select-triplet.vue?vue&type=script&lang=js&"
export * from "./select-triplet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports